import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=4298fabf&"
import script from "./invoice.vue?vue&type=script&lang=js&"
export * from "./invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4298fabf')) {
      api.createRecord('4298fabf', component.options)
    } else {
      api.reload('4298fabf', component.options)
    }
    module.hot.accept("./invoice.vue?vue&type=template&id=4298fabf&", function () {
      api.rerender('4298fabf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/customers/Edit/invoice.vue"
export default component.exports